<script setup lang="ts">
const { t } = useI18n()

defineProps<{
  canMoveUp: boolean
  canMoveDown: boolean
}>()

const emit = defineEmits<{
  (e: 'move-up'): void
  (e: 'move-down'): void
  (e: 'duplicate'): void
  (e: 'delete'): void
}>()
</script>

<template>
  <div
    class="absolute -right-12 top-1/2 z-20 flex -translate-y-1/2 flex-col gap-1 rounded-xl bg-white p-1.5 shadow-lg ring-1 ring-border"
    @click.stop
  >
    <div
      class="drag-handle flex h-8 w-8 cursor-grab items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground-secondary active:cursor-grabbing"
      :title="t('pages.email.emailTemplateCreatePage.toolbar.drag')"
    >
      <BaseIcon name="IconoirDrag" class="h-4 w-4" />
    </div>

    <div class="my-0.5 h-px bg-muted" />

    <button
      type="button"
      class="flex h-8 w-8 items-center justify-center rounded-lg transition-colors"
      :class="
        canMoveUp
          ? 'text-muted-foreground hover:bg-accent hover:text-foreground-secondary'
          : 'cursor-not-allowed text-foreground-disabled'
      "
      :disabled="!canMoveUp"
      :title="t('pages.email.emailTemplateCreatePage.toolbar.moveUp')"
      @click="emit('move-up')"
    >
      <BaseIcon name="IconoirArrowUp" class="h-4 w-4" />
    </button>

    <button
      type="button"
      class="flex h-8 w-8 items-center justify-center rounded-lg transition-colors"
      :class="
        canMoveDown
          ? 'text-muted-foreground hover:bg-accent hover:text-foreground-secondary'
          : 'cursor-not-allowed text-foreground-disabled'
      "
      :disabled="!canMoveDown"
      :title="t('pages.email.emailTemplateCreatePage.toolbar.moveDown')"
      @click="emit('move-down')"
    >
      <BaseIcon name="IconoirArrowDown" class="h-4 w-4" />
    </button>

    <div class="my-0.5 h-px bg-muted" />

    <button
      type="button"
      class="flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground-secondary"
      :title="t('pages.email.emailTemplateCreatePage.toolbar.duplicate')"
      @click="emit('duplicate')"
    >
      <BaseIcon name="IconoirCopy" class="h-4 w-4" />
    </button>

    <button
      type="button"
      class="flex h-8 w-8 items-center justify-center rounded-lg text-red-400 transition-colors hover:bg-red-50 hover:text-red-600"
      :title="t('pages.email.emailTemplateCreatePage.toolbar.delete')"
      @click="emit('delete')"
    >
      <BaseIcon name="IconoirTrash" class="h-4 w-4" />
    </button>
  </div>
</template>
